import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEditor = () => {
	const [convertedText, setConvertedText] = useState(
		"<h2>What do I want to accomplish today?</h2><ul><li>Your most urgent item...</li><li>Your most important item...</li><li>One more thing you want to get done...</li><li></li></ul>"
	);

	useEffect(() => {
		const savedText = localStorage.getItem("text");
		if (savedText != null || savedText != undefined) {
			setConvertedText(savedText);
		}
	}, []);

	const handleChange = (e) => {
		setConvertedText(e);
		localStorage.setItem("text", e);
	};

	return (
		<div className="py-4">
			<ReactQuill
				theme="snow"
				value={convertedText}
				onChange={(e) => handleChange(e)}
				style={{ minHeight: "300px", fontFamily: "Muli" }}
			/>
		</div>
	);
};

export default TextEditor;
